{
  "version": 1,
  "asset_id": "65dfaa24-433c-49fa-b5d7-0235e7200551",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/65dfaa24-433c-49fa-b5d7-0235e7200551/hero-fetiche-poster.jpg",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/65dfaa24-433c-49fa-b5d7-0235e7200551/hero-fetiche-poster.jpg",
  "original_filename": "hero-fetiche-poster.jpg",
  "size": 31820,
  "content_type": "image/jpeg",
  "created_at": "2026-11-03T17:23:26Z"
}
